import { cn } from '../../utils/cn';

export const FORM_LABEL_CLASS = 'block text-sm !leading-relaxed font-medium gray-900 mb-2';

export const FORM_ERROR_CLASS = 'mt-1 text-sm text-[#cf4949]';

export const INPUT_BASE_CLASS =
    'w-full px-2.5 py-3 border border-custom-border-primary rounded-md text-sm !leading-relaxed text-custom-text-primary placeholder:text-custom-text-placeholder focus-within:shadow-none focus-within:ring-offset-0 focus-within:ring-custom-blue-primary disabled:cursor-not-allowed';

export const INPUT_ERROR_CLASS =
    'text-custom-error-primary border-custom-error-primary focus-within:ring-custom-error-primary';

export const OTP_SLOT_BASE_CLASS =
    'relative flex p-6 w-11 lg:w-14 h-12 items-center justify-center rounded border border-custom-border-primary bg-white text-2xl leading-none text-custom-gray-900 transition-colors duration-150';

export const OTP_SLOT_ACTIVE_CLASS = 'border-primary';

export const OTP_SLOT_ERROR_CLASS = 'border-custom-error-primary';

export const OTP_SLOT_DISABLED_CLASS = 'opacity-50 cursor-not-allowed';